export default {
    addReserveProject:'/index.php/cqh/Reserveproject/addProject',//新建修改储备项目
    reserveProjectList:'/index.php/cqh/Reserveproject/projectList',//储备项目列表
    deleteReserveProject:'/index.php/cqh/Reserveproject/deleteProject',//删除储备项目
    reserveProjectDetail:'/index.php/cqh/Reserveproject/projectDetail',//储备项目详情
    reserveprojectUpgrade:'index.php/cqh/Reserveproject/upgrade',//储备项目升级
    toProject:'/index.php/cqh/Reserveproject/toProject',//储备项目转正式项目
}